import React from "react";
import { Link } from "react-router-dom";

// The "no file? fill a template" card under the upload card, styled in App.css
const TemplateCta = () => (
  <Link to="/templates" className="template-cta">
    <span className="template-cta-icon">
      <i className="fas fa-file-signature"></i>
    </span>
    <span className="template-cta-body">
      <span className="template-cta-title">
        <span className="template-cta-badge">Шинэ</span>
        Файлгүй юу?
      </span>
      <span className="template-cta-text">
        Бэлэн загвар бөглөөд киоскоос шууд хэвлээрэй
      </span>
      <span className="template-cta-tags">
        <span>Өргөдөл</span>
        <span>CV</span>
        <span>Нүүр хуудас</span>
      </span>
    </span>
    <span className="template-cta-go">
      Загвар сонгох
      <span className="template-cta-arrow">
        <i className="fas fa-arrow-right"></i>
      </span>
    </span>
  </Link>
);

export default TemplateCta;
